



















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class ExpansionPanel extends Vue {
  @Prop()
  readonly title: string;
  @Prop({ default: false })
  readonly outlined: boolean;
  @Prop({ default: false })
  readonly readonly: boolean;
  @Prop({ default: false })
  readonly eager: boolean;
}
